import { Injectable } from '@angular/core';
import { driver, DriveStep, Driver } from 'driver.js';

@Injectable({
  providedIn: 'root'
})
export class DriverTourService {
  private driverInstance: Driver | null = null;

  constructor() {}

  /**
   * Inicializa Driver.js con configuración personalizada
   */
  private initDriver(): Driver {
    if (!this.driverInstance) {
      this.driverInstance = driver({
        showProgress: true,
        showButtons: ['next', 'previous', 'close'],
        steps: [],
        popoverClass: 'driverjs-theme',
        nextBtnText: 'Siguiente',
        prevBtnText: 'Anterior',
        doneBtnText: 'Entendido',
        progressText: '{{current}} de {{total}}',
        onDestroyed: () => {
          this.driverInstance = null;
        }
      });
    }
    return this.driverInstance;
  }

  /**
   * Muestra un tour para guiar al usuario hacia el perfil cuando tiene balance negativo
   */
  showNegativeBalanceTour(): void {
    const steps: DriveStep[] = [
      {
        element: 'body',
        popover: {
          title: '💳 Pagar Recargo',
          description: 'Tu balance actual no es suficiente para completar esta compra. Ve a Perfil, para pagar el recargo pendiente.',
          side: 'bottom',
          align: 'center'
        }
      },
      {
        element: '[data-tour="profile-link"]',
        popover: {
          title: '👤 Ve a tu Perfil',
          description: 'Haz clic aquí para ir a tu perfil donde podrás recargar tu cuenta y gestionar tus métodos de pago.',
          side: 'bottom',
          align: 'start'
        }
      }
    ];

    const driverInstance = this.initDriver();
    driverInstance.setSteps(steps);
    driverInstance.drive();
  }

  /**
   * Muestra un popup apuntando al enlace de perfil para balance negativo
   */
  showNegativeBalancePopup(): void {
    if (!this.driverInstance) {
      this.initDriver();
    }

    // console.log('Buscando elemento profile-link...');

    // Intentar encontrar el elemento con diferentes estrategias
    let profileElement = document.querySelector('[data-tour="profile-link"]');

    if (!profileElement) {
      // Esperar un poco más y volver a intentar
      setTimeout(() => {
        profileElement = document.querySelector('[data-tour="profile-link"]');
        // console.log('Segundo intento - Elemento encontrado:', !!profileElement);

        if (profileElement) {
          this.highlightProfileLink(profileElement);
        } else {
          console.warn('Elemento profile-link no encontrado después de 2 intentos');
          this.showFallbackPopup();
        }
      }, 500);
    } else {
      // console.log('Elemento profile-link encontrado inmediatamente');
      this.highlightProfileLink(profileElement);
    }
  }

  private highlightProfileLink(profileElement: Element): void {
    // console.log('Mostrando highlight en elemento perfil');
    this.driverInstance!.highlight({
      element: profileElement as HTMLElement,
      popover: {
        title: '💰 Pagar Recargo',
        description: 'Tu balance actual no es suficiente para completar esta compra. Ve a Perfil, para pagar el recargo pendiente.',
        side: 'bottom',
        align: 'start',
        showButtons: ['next'],
        nextBtnText: 'Ir a pagar',
        onNextClick: () => {
          // console.log('Usuario hizo clic en "Ir a pagar"');
          // Hacer clic en el enlace de perfil y cerrar el popover
          (profileElement as HTMLElement).click();
          this.driverInstance!.destroy();
        }
      }
    });
  }

  private showFallbackPopup(): void {
    // console.log('Mostrando popup fallback centrado');
    this.driverInstance!.highlight({
      popover: {
        title: '💰 Pagar Recargo',
        description: 'Tu balance actual no es suficiente para completar esta compra. Ve a Perfil, para pagar el recargo pendiente.',
        showButtons: ['next'],
        nextBtnText: 'Ir a pagar',
        onNextClick: () => {
          window.location.href = '/auth/perfil';
        }
      }
    });
  }

  /**
   * Destruye la instancia actual de Driver.js
   */
  destroy(): void {
    if (this.driverInstance) {
      this.driverInstance.destroy();
      this.driverInstance = null;
    }
  }

  /**
   * Verifica si hay un tour activo
   */
  isActive(): boolean {
    return this.driverInstance !== null;
  }
}
